.fa{z-index:2;}